import { callAuthorizedGraphQLEndpoint } from '../../../Module/graphQL'

export default async campaignId => {
  const query = `query 
    ($campaignId:ID!) {
      campaign(id:$campaignId){
        id
        name
        type
        cityPlans {
          nodes {
            city {
              id
              name
            }
          }
        }
        country {
            code
            countryDefaultSettings {
              h2hDistributionCosts,
              d2dDistributionCosts,

            },
            citiesSettings {
              nodes {
                id,
                name, 
                h2hDistributionCosts,
                d2dDistributionCosts,
              }
            },
            cities {
                edges {
                    node {
                        id
                        name
                    }
                }
            }
        }
    }
}`

  return callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
}
